import { render } from "./ComponentCard.vue?vue&type=template&id=79c14db9"
import script from "./ComponentCard.vue?vue&type=script&lang=js"
export * from "./ComponentCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__